export function setActiveConversation(data) {
  return {
    type: 'SET_ACTIVE_CONVERSATION',
    payload: data,
  };
};